export default {"src":"/login-app/[GIT_HASH]/_next/static/media/asset_non_sda.14f1e354.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};